<div mat-dialog-content>
  <div class="mat-dialog-header">
    <h3>Prescrição Não Padronizada</h3>
  </div>
  <form class="form" [formGroup]="prescriptionModel" (ngSubmit)="onSubmit()">
    <div class="mat-dialog-content">
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Descrição</mat-label>
            <input [readonly]="this.data.readOnly" matInput formControlName="description">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Quantidade</mat-label>
            <input formControlName="quantity" matInput [readonly]="this.data.readOnly" type="text">
          </mat-form-field>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Unidade</mat-label>
            <mat-select formControlName="idMeasurementUnit">
              @for (item of measurementUnitList; track item) {
                <mat-option [value]="item.idMeasurementUnit">
                  {{item.measurementUnitName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Frequência</mat-label>
            <input [readonly]="this.data.readOnly" matInput formControlName="frequency">
          </mat-form-field>
        </div>
        @if (this.data.lookupMedicalCareResponse?.listPresentation) {
          <div class="col-12 col-sm-6 col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Apresentação</mat-label>
              <mat-select (ngModelChange)="onChangePresentation($event)" formControlName="idPresentation">
                @for (item of this.data.lookupMedicalCareResponse.listPresentation; track item) {
                  <mat-option
                    [value]="item.idPresentation">
                    {{item.presentationName}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
      @if (this.prescriptionModel.get('idPresentation') && this.prescriptionModel.get('idPresentation').value == presentationOthersEnum.valueOf()) {
        <div
          class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Descreva a apresentação</mat-label>
              <textarea matInput formControlName="presentation"></textarea>
            </mat-form-field>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Observação</mat-label>
            <textarea [readonly]="this.data.readOnly" matInput formControlName="observation"></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="footer-panel-modal-list">
        <div class="row">
          @if (!this.data.readOnly) {
            <div class="col-6">
              <a mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">Cancelar</a>
            </div>
          }
          @if (!this.data.readOnly) {
            <div class="col-6">
              <button mat-flat-button type="submit" color="primary" class=" btn-block">
                <span>Salvar</span>
              </button>
            </div>
          }
          <div class="col-12">
            @if (this.data.readOnly) {
              <a mat-flat-button color="primary" class="btn-block"
              (click)="clickCancel()">Ok</a>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
</div>